import type { LocationQuery } from 'vue-router';
import axiosInstance from '../../config/axios';
import type { Order } from '../../types/Order';
import type { APIResp, APIRespPaginated } from '../../types/APIService';
import { parseOrders } from '../../utils/serverParsing';

const apiRoute = 'admin/orders';

export async function fetchAdminOrders(routeQuery: LocationQuery) {
  try {
    const res = await axiosInstance.get<APIRespPaginated<Order[]>>(apiRoute, { params: routeQuery });
    parseOrders(res.data.data.data);
    return res.data.data;
  }
  catch {
    return {
      data: [],
      total_count: 0,
      pages: 0,
    };
  }
}

export async function updateAdminOrder({ id, ...order }: Partial<Order> & { id: number }, ac?: AbortController) {
  const body = { ...order };
  if (body.delivery_time) {
    body.delivery_time = body.delivery_time.getTime() as any;
  }
  if (body.address === null) {
    body.address = {} as any;
  }
  try {
    await axiosInstance.patch(`/${apiRoute}/${id}`, body, { signal: ac?.signal ?? undefined });
    return true;
  }
  catch {
    return false;
  }
}

export async function fetchActiveOrders() {
  try {
    const res = await axiosInstance.get<APIResp<Order[]>>(`${apiRoute}/board`);
    parseOrders(res.data.data);
    return res.data.data;
  }
  catch {
    return [];
  }
}

export async function deleteAdminOrder(id: number) {
  try {
    await axiosInstance.delete<APIResp<Order[]>>(`${apiRoute}/${id}`);
    return true;
  }
  catch {
    return false;
  }
}
